import Financing from 'financing/components/Financing/Financing.jsx';
import FinancingProvider from 'financing/FinancingProvider.jsx';
import DepositState from 'financing/components/DepositState/DepositState.jsx';
import FinancingState from 'financing/components/FinancingState/FinancingState.jsx';

import en from 'financing/i18n/en.json';
import fr from 'financing/i18n/fr.json';

const root = Financing;
const provider = FinancingProvider;
const main = provider;

const Translations = {
    en,
    fr,
};

export const widgets = {
    Financing: {
        components: {
            root,
            provider,
            main,
            DepositState,
            FinancingState,
        },
        Translations,
    },
};

export default {
    root,
    provider,
    Financing: main,
    Translations,
    DepositState,
    FinancingState,
};
